
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, ServiceTypeModel, IServiceTypeModel } from '@/services/api.service';

  import ServiceTypeCreate from './ServiceTypeCreate.vue';
  import ServiceTypeEdit from './ServiceTypeEdit.vue';

  import * as StringUtils from '@/utilities/string.utils';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import toCurrencyFormatter from '@/filters/tocurrency.formatter';

  @Component({
    components: {
      ServiceTypeCreate,
      ServiceTypeEdit
    },
    filters: {
      toJobItemType: toJobItemTypeFormatter,
      toCurrency: toCurrencyFormatter
    }
  })
  export default class ServiceTypeList extends Vue {
    private serviceTypes: ServiceTypeModel[] = [];
    private serviceTypeInEdit: IServiceTypeModel | null = null;

    protected mounted() {
      this.fetchServiceTypes();
    }

    private fetchServiceTypes() {
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      const serviceTypes = clientService.getServiceTypes().then(data => {
        const sortedData = data.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''));
        this.serviceTypes = sortedData;
      });
    }

    public onServiceTypeAddRequested() {
      console.log('EVENT:Add Service Type requested ');
      this.$modal.show('modal-servicetype-create');
    }

    public onServiceTypeEditRequested(value: IServiceTypeModel) {
      console.log('EVENT:Edit service type requested for ' + value.gid);
      this.serviceTypeInEdit = value;
      this.$modal.show('modal-servicetype-edit');
    }
    private onServiceTypeCreated(servicetype: IServiceTypeModel) {
      // make sure this job item is for this job
      const newEmp = new ServiceTypeModel(servicetype);
      this.serviceTypes.push(newEmp);
    }

    private onServiceTypeUpdated(servicetype: IServiceTypeModel) {
      console.log('Received servicetype-updated event');
      const theServiceType = this.serviceTypes.find(item => item.gid === servicetype.gid);
      if (theServiceType !== undefined) {
        Object.assign(theServiceType, servicetype);
      }
    }
  }
